import React from "react";
import hearderbg from "../Assest/new_logo_withshreebalaji.png";

export default function PrivacyPolicy() {
  return (
    <div className="text-gray-800 overflow-hidden">

      {/* HERO */}
      <section
        className="relative py-28 bg-cover bg-center"
        style={{ backgroundImage: `url(${hearderbg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            OUR POLICIES
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
           Your privacy, security and control matter to us.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-5xl mx-auto px-6 space-y-12 text-gray-700 leading-relaxed">

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Introduction</h2>
            <p>
              This Privacy Policy outlines how we collect, use, disclose, retain, and safeguard your personal data when you interact with our website, services, or platforms. Our commitment to transparency and accountability ensures that your personal data is handled with the utmost care.
            </p>
            <p className="mt-3">
              This Privacy Policy applies globally to all users and ensures compliance with applicable regional and international regulations including GDPR, CCPA, and other relevant laws. By accessing our website or using our services, you consent to the practices described herein.
            </p>
            <p className="mt-3">
              This Privacy Policy applies to all interactions you have with <strong>ShreeBalajee Connect Pvt. Ltd. (BINGOPAY)</strong>, whether through our website, services, or digital platforms.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Information We Collect</h2>
            <p>We collect information to provide tailored services and improve your experience.</p>
            <ul className="list-disc list-inside mt-3 space-y-2">
              <li>Personal information such as name, address, email, phone number, PAN, Aadhaar, etc.</li>
              <li>Behavioural data including interaction patterns, preferences, and feedback.</li>
              <li>Technical data like browser type, IP address, device details, cookies, and geolocation.</li>
              <li>Device sensor data (if accessed via mobile applications).</li>
              <li>Biometric data strictly for regulatory compliance when required.</li>
            </ul>
            <p className="mt-3">
              We only collect the minimum necessary data and anonymize unused data for research purposes.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Methods of Data Collection</h2>
            <p>
              We collect data through direct interactions (registrations, forms, surveys), automated technologies (cookies, logs, web beacons), and third-party sources such as partners and public records, in compliance with applicable laws.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Use of Information</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Facilitating transactions, onboarding, and KYC processes.</li>
              <li>Meeting regulatory and legal obligations.</li>
              <li>Preventing fraud and ensuring security.</li>
              <li>Sending service updates and promotional communications.</li>
              <li>Improving services using analytics and behavioural insights.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Legal Basis for Processing</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Consent</li>
              <li>Contractual Necessity</li>
              <li>Legal Compliance</li>
              <li>Legitimate Interests</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Data Sharing and Disclosure</h2>
            <p>
              Data may be shared with authorized vendors, regulatory authorities, or transferred during mergers/acquisitions, always subject to strict confidentiality and legal safeguards.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Data Security</h2>
            <p>
              We conduct regular audits, penetration testing, and employee training to ensure strong security measures. In case of a data breach, affected users and authorities will be notified as required by law.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Data Retention</h2>
            <p>
              Data retention is based on regulatory and business requirements. Transaction data may be retained up to 10 years. Data is securely deleted when no longer required.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Your Rights</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Right to Access</li>
              <li>Right to Rectification</li>
              <li>Right to Erasure</li>
              <li>Right to Restrict Processing</li>
              <li>Right to Data Portability</li>
              <li>Right to Object</li>
              <li>Right to Human Intervention in Automated Decisions</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Cookies and Tracking</h2>
            <p>
              We use cookies and tracking technologies to improve functionality and user experience. Users can manage cookie preferences through our cookie settings tool.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Children’s Privacy</h2>
            <p>
              Our services are intended for individuals aged 18 and above. We do not knowingly collect data from minors without parental consent.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Grievance Redressal</h2>
            <p>For any concerns, please contact:</p>
            <ul className="list-disc list-inside mt-3 space-y-2">
              <li>Email: support@bingopays.in</li>
              <li>Address: #879/13, Kurukshetra, Haryana – 136118, India</li>
            </ul>
            <p className="mt-3">We aim to resolve grievances within 15 working days.</p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Governing Law</h2>
            <p>
              This Privacy Policy is governed by the laws of India. Disputes shall be resolved through arbitration under the Arbitration and Conciliation Act, 1996. The seat of arbitration shall be Haryana, India.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}
